import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

const timeout = ServiceValues.timeout;
const baseUrl = ServiceValues.base_url_local;

async function getUsuarioByLocalStorage() {
  try{
    const api = ServiceAxios(baseUrl, timeout);
    const user = JSON.parse(localStorage.getItem('auth'));
    if (user) {
      const dados = await api.get(`usuarios/${user.result.idUsuario}`);
      if (dados) {
        if (dados.data) {
          return dados.data;
        }
        else {
          return {
            isSuccess: false,
            message: Values.MessageValues.erro_catch,
            result: []
          }
        }
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        };
      }
    }
  }
  catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

async function updateUsuario(usuario) {
  try{
    console.log('oi2');
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.put(`usuarios/${usuario.idUsuario}`, usuario);
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  }
  catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

export {
  getUsuarioByLocalStorage,
  updateUsuario
};
